export interface IPoiCutoverConfiguration {
  poiCutoverConfigurationId: string;
  poiCutoverStrategy: string;
  forcedCutoverTime: string;
}
